module.exports = require("mitt");


//////////////////
// WEBPACK FOOTER
// external "mitt"
// module id = 16
// module chunks = 0 1